<template>
    <accordion-setting
        id="settingsText"
        title="Configurações Texto"
        :visible="visible"
    >
        <!-- CONFIGURAÇÃO DE LARGURA -->
        <div class="py-2">
            <setting-frame-width
                :item="item"
                @onChangeWidth="onChangeWidth"
            />
        </div>

        <!-- CONFIGURAÇÃO DE COR DE FUNDO -->
        <div class="py-2">
            <setting-frame-background-color
                :item="item"
                @onChangeBackgroundColor="onChangeBackgroundColor"
            />
        </div>

        <!-- CONFIGURAÇÃO DE IMAGEM DE FUNDO -->
        <div class="py-2">
            <setting-frame-background-image
                :url="item.extra.background_image.uri"
                @onChangeBackgroundImage="onChangeBackgroundImage"
            />
        </div>
        
        <!-- CONFIGURAÇÃO DE PONTO FOCAL DA IMAGEM DE FUNDO (PRECISA TER IMAGEM PARA MOSTRAR) -->
        <div class="py-2" v-if="this.item.extra.background_image.uri != null && this.item.extra.background_image.uri != ''">
            <setting-frame-background-image-focal-point
                :url="item.extra.background_image.uri"
                :initialPosition="item.extra.background_image_focal_point"
                @onChangeBackgroundImageFocalPoint="onChangeBackgroundImageFocalPoint"
            />
        </div>

        <!-- CONFIGURAÇÃO DE OPACIDADE DA IMAGEM DE FUNDO (PRECISA TER IMAGEM PARA MOSTRAR) -->
        <div class="py-2" v-if="this.item.extra.background_image.uri != null && this.item.extra.background_image.uri != ''">
            <setting-frame-background-image-opacity
                :item="item"
                @onChangeBackgroundImageOpacity="onChangeBackgroundImageOpacity"
            />
        </div>

        <!-- CONFIGURAÇÃO DE MARGIN -->
        <div class="py-2">
            <setting-frame-margin
                :item="item"
                @onChangeMargin="onChangeMargin"
                @onChangeMarginMobile="onChangeMarginMobile"
                @onChangeLockMarginMobile="onChangeLockMarginMobile"
            />
        </div>
        
        <!-- CONFIGURAÇÃO DE PADDING -->
        <div class="py-2">
            <setting-frame-padding
                :item="item"
                @onChangePadding="onChangePadding"
                @onChangePaddingMobile="onChangePaddingMobile"
                @onChangeLockPaddingMobile="onChangeLockPaddingMobile"
            />
        </div>
    </accordion-setting>
</template>

<script>
import FlickerCarousel from "../atoms/FlickerCarousel.vue";
import SettingFrameTypeGallery from "../atoms/SettingFrameTypeGallery.vue";
import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import SettingFrameAdvanced from "../atoms/SettingFrameAdvanced.vue";
import SettingFrameBackgroundColor from '../atoms/SettingFrameBackgroundColor.vue';
import SettingFrameBackgroundImage from '../atoms/SettingFrameBackgroundImage.vue';
import SettingFrameMargin from '../atoms/SettingFrameMargin.vue';
import SettingFramePadding from '../atoms/SettingFramePadding.vue';
import ImageCarousel from './ImageCarousel.vue';
import SettingFrameBackgroundImageOpacity from '../atoms/SettingFrameBackgroundImageOpacity.vue';
import BaseImage from '../atoms/BaseImage.vue';
import SettingFrameBackgroundImageFocalPoint from '../atoms/SettingFrameBackgroundImageFocalPoint.vue';
import AccordionSetting from '../atoms/AccordionSetting.vue';

export default {
    name: "SettingsFrameText",
    components: {
        SettingFrameWidth,
        SettingFrameTypeGallery,
        SettingFrameAdvanced,
        SettingFrameBackgroundColor,
        FlickerCarousel,
        SettingFrameBackgroundImage,
        SettingFrameMargin,
        SettingFramePadding,
        ImageCarousel,
        SettingFrameBackgroundImageOpacity,
        BaseImage,
        SettingFrameBackgroundImageFocalPoint,
        AccordionSetting,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            backgroundImageOpacityDefalut: 80,
            backgroundImageFocalPoint: {
                x: 50,
                y: 50,
            },
        }
    },  
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        onChangeBackgroundColor(event) {
            if (event.backgroundColor) {
                this.item.extra.background_color = event.backgroundColor;
                
                this.handleSaveFrameConfig();
            } else {
                this.resetSettings();
            }
        },
        resetSettings() {
            this.item.extra.background_color = null;

            this.handleSaveFrameConfig();
        },
        onChangeBackgroundImage(event) {
            this.item.extra.background_image = {
                uri: event,
                id: null,
                width: null,
                height: null
            };

            this.onChangeBackgroundImageOpacity(this.backgroundImageOpacityDefalut);
            this.onChangeBackgroundImageFocalPoint(this.backgroundImageFocalPoint);

            this.$emit("saveItemChanges", this.item, false);
        },
        onChangePadding(value) {
            this.item.extra.padding = value;

            this.handleSaveFrameConfig();
        },
        onChangePaddingMobile(value) {
            this.item.extra.padding_mobile = value;

            this.handleSaveFrameConfig();
        },
        onChangeLockPaddingMobile(value) {
            this.item.extra.padding_mobile_lock = value;

            this.handleSaveFrameConfig();
        },
        onChangeMargin(value) {
            this.item.extra.margin = value;

            this.handleSaveFrameConfig();
        },
        onChangeMarginMobile(value) {
            this.item.extra.margin_mobile = value;

            this.handleSaveFrameConfig();
        },
        onChangeLockMarginMobile(value) {
            this.item.extra.margin_mobile_lock = value;

            this.handleSaveFrameConfig();
        },
        onChangeWidth(item) {
            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;

            this.handleSaveFrameConfig();
        },
        onChangeBackgroundImageOpacity(event) {
            this.$set(this.item.extra, 'background_image_opacity', event);
            
            this.handleSaveFrameConfig();
        },
        onChangeBackgroundImageFocalPoint(event) {
            if (this.item.extra.background_image_focal_point == null) {
                this.item.extra.background_image_focal_point = this.backgroundImageFocalPoint;
            }

            this.$set(this.item.extra.background_image_focal_point, 'x', event.x);
            this.$set(this.item.extra.background_image_focal_point, 'y', event.y);

            this.handleSaveFrameConfig();
        },
    },
    created() {
        if (!this.item.extra) {
            this.item.extra = {};
        }

        if (!this.item.extra.background_color) {
            this.item.extra.background_color = null;
        }

        if (!this.item.extra.background_image) {
            this.item.extra.background_image = {
                uri: null,
                id: null,
                width: null,
                height: null
            };
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameText.vue